import type { GlobalThemeOverrides } from 'naive-ui'

export const themeNaiveUi: GlobalThemeOverrides = {
  Button: {
    borderRadiusMedium: '9999px',
    border: '.5px solid #DFE3EC',
    borderRadiusTiny: '9999px',
    borderRadiusSmall: '9999px',
    borderRadiusLarge: '9999px',
    colorError: '#EF4444FF',
    colorHoverError: '#F87171FF',
    colorPressedError: '#DC2626FF',
    colorDisabledError: '#EF4444FF',
    colorFocusError: '#EF4444FF',
    textColorTextError: '#EF4444FF',
    textColorTextHoverError: '#F87171FF',
    textColorTextPressedError: '#DC2626FF',
    textColorTextFocusError: '#F87171FF',
    textColorGhostError: '#EF4444FF',
    textColorGhostHoverError: '#F87171FF',
    textColorGhostPressedError: '#DC2626FF',
    textColorGhostFocusError: '#F87171FF',
    textColorGhostDisabledError: '#EF4444FF',
    rippleColorError: '#EF4444FF',
    heightLarge: '48px',
    heightMedium: '40px',
    heightSmall: '36px',
    heightTiny: '28px',
    colorQuaternaryHover: 'rgba(110, 1, 162, 0.05)',
    colorQuaternaryPressed: 'rgba(110, 1, 126, 0.12)',
    colorDisabledPrimary: 'rgba(0, 0, 0, 0.10)',
    opacityDisabled: '0.4',
    textColorDisabledPrimary: 'rgba(13, 0, 26, 0.70)',
    colorTertiary: 'rgba(233, 237, 244, 0.4)',
    colorTertiaryHover: 'rgba(233, 237, 244, 0.65)',
    colorTertiaryPressed: 'rgba(233, 237, 244, 0.4)',
    textColorGhost: 'rgba(37, 0, 59, 1)',
    textColorTertiary: '#444B5Dff',
    borderDisabledPrimary: '1px solid transparent',
    fontSizeSmall: '13px',
    fontSizeLarge: '16px',
  },
  common: {
    primaryColor: '#6E01A2FF',
    primaryColorHover: '#9500D7FF',
    primaryColorPressed: '#590085FF',
    textColorBase: '#0D001AFF',
    textColor1: 'rgba(37, 0, 59, 1)',
    errorColor: '#FF2056FF',
    errorColorHover: '#FF637EFF',
    errorColorPressed: '#EC003FFF',
    errorColorSuppl: '#FF2056FF',
    primaryColorSuppl: '#6E01A2FF',
    infoColor: '#2B7FFFFF',
    infoColorHover: '#51A2FFFF',
    infoColorPressed: '#155DFCFF',
    infoColorSuppl: '#2B7FFFFF',
    successColor: '#00BC7DFF',
    successColorHover: '#00D492FF',
    successColorPressed: '#009966FF',
    successColorSuppl: '#00BC7DFF',
    warningColor: '#FD9A00FF',
    warningColorHover: '#FFBA00FF',
    warningColorPressed: '#E17100FF',
    warningColorSuppl: '#FD9A00FF',
    textColor3: 'rgba(117, 126, 146, 1)',
    textColor2: 'rgba(37, 0, 59, 1)',
    placeholderColor: 'rgba(174, 182, 200, 1)',
    textColorDisabled: 'rgba(13, 0, 26, 0.7)',
    placeholderColorDisabled: 'rgba(205, 210, 223, 1)',
    iconColor: 'rgba(117, 126, 146, 1)',
    iconColorHover: 'rgba(151, 160, 181, 1)',
    iconColorDisabled: 'rgba(205, 210, 223, 1)',
    dividerColor: 'rgba(233, 237, 244, 1)',
    borderColor: 'rgba(233, 237, 244, 1)',
    progressRailColor: 'rgba(174, 182, 200, 1)',
    railColor: 'rgba(205, 210, 223, 1)',
    popoverColor: '#ffffffFF',
    tableColor: '#F8FAFCFF',
    cardColor: '#ffffffFF',
    modalColor: '#ffffffFF',
    bodyColor: '#ffffffFF',
    tagColor: '#F8FAFCFF',
    scrollbarWidth: '4px',
  },
  Menu: {
    borderRadius: '999px',
    itemHeight: '40px',
    fontSize: '14px',
    color: '#DD202000',
    groupTextColor: 'rgb(118, 124, 130)',
    itemColorHover: '#6E01A20A',
    itemTextColor: '#444B5Dff',
    itemTextColorHover: '#444B5DFF',
    itemTextColorHorizontal: '#444B5DFF',
    itemIconColor: '#AEB6C8ff',
    itemIconColorHover: '#AEB6C8FF',
    arrowColor: '#AEB6C8FF',
    arrowColorHover: '#AEB6C8FF',
  },
  DataTable: {
    borderColor: 'var(--color-border)',
    thPaddingSmall: '16px',
    thPaddingLarge: '20px',
    thPaddingMedium: '18px',
    tdPaddingSmall: '10px',
    sorterSize: '20px',
    resizableContainerSize: '16px',
    actionDividerColor: 'rgb(239, 239, 245)',
    borderRadius: '16px',
  },
  Collapse: {
    titlePadding: '16px 16px 16px 0px',
    itemMargin: '0',
    titleFontWeight: '500',
  },
  Upload: {
    borderRadius: '6px',
    draggerColor: 'rgb(250, 250, 252)',
    itemDisabledOpacity: '0.3',
    draggerBorderHover: '1px dashed #6E01A2',
    draggerBorder: '1px solid #E9EDF4',
  },
  Tag: {
    borderRadius: '16px',
    padding: '8px 12px',
    heightTiny: '20px',
    heightSmall: '24px',
    heightMedium: '32px',
    heightLarge: '36px',
    fontSizeTiny: '11px',
    fontSizeSmall: '13px',
    fontSizeMedium: '13px',
    fontSizeLarge: '13px',
    colorBordered: 'rgba(249, 251, 253, 1)',
    colorPrimary: 'rgba(243, 232, 255, 1)',
    borderPrimary: '1px solid rgba(110, 1, 162, 1)',
    colorError: 'rgba(255, 228, 230, 1)',
    colorBorderedError: 'rgba(255, 241, 242, 1)',
    closeColorHoverError: 'rgba(255, 228, 230, 1)',
    closeColorPressedError: 'rgba(255, 241, 242, 1)',
    colorWarning: 'rgba(255, 237, 212, 1)',
    colorBorderedWarning: 'rgba(255, 247, 237, 1)',
    closeColorHoverWarning: 'rgba(255, 237, 212, 1)',
    closeColorPressedWarning: 'rgba(255, 247, 237, 1)',
    colorSuccess: 'rgba(236, 253, 245, 1)',
    colorBorderedSuccess: 'rgba(236, 253, 245, 1)',
    closeColorHoverSuccess: 'rgba(208, 250, 229, 1)',
    closeColorPressedSuccess: 'rgba(236, 253, 245, 1)',
    colorInfo: 'rgba(219, 234, 254, 1)',
    colorBorderedInfo: 'rgba(239, 246, 255, 1)',
    closeColorHoverInfo: 'rgba(219, 234, 254, 1)',
    closeColorPressedInfo: 'rgba(239, 246, 255, 1)',
    closeColorHover: 'rgba(233, 237, 244, 1)',
    closeColorPressed: 'rgba(249, 251, 253, 1)',
    colorBorderedPrimary: 'rgba(250, 245, 255, 1)',
    closeColorHoverPrimary: 'rgba(243, 232, 255, 1)',
    closeColorPressedPrimary: 'rgba(250, 245, 255, 1)',
    colorHoverCheckable: 'rgba(243, 247, 252, 1)',
    colorPressedCheckable: 'rgba(233, 237, 244, 1)',
  },
  Dropdown: {
    padding: '4px 4px',
    borderRadius: '10px',
    optionHeightMedium: '36px',
    fontSizeMedium: '13px',
    fontSizeSmall: '11px',
    optionColorHover: 'rgba(0, 0, 0, 0.05)',
    dividerColor: 'rgba(233, 237, 244, 1)',
    optionIconSizeMedium: '18px',
    optionOpacityDisabled: '0.3',
  },
  Input: {
    paddingTiny: '5px 10px',
    heightTiny: '28px',
    heightSmall: '36px',
    heightMedium: '40px',
    heightLarge: '48px',
    fontSizeMedium: '14px',
    fontSizeSmall: '13px',
    fontSizeLarge: '16px',
    borderRadius: '8px',
    paddingSmall: '8px 12px',
    paddingMedium: '9px 12px',
    paddingLarge: '16px 16px',
  },
  Select: {
    peers: {
      InternalSelection: {
        borderRadius: '8px',
        arrowColor: '#97A0B5',
        border: '1px solid #e7ebf3',
        textColor: '#25003B',
        colorActive: '#fafcff',
        heightTiny: '28px',
        heightSmall: '36px',
        heightMedium: '40px',
        heightLarge: '48px',
      },
      InternalSelectMenu: {
        borderRadius: '8px',
      },
    },
  },
  Dialog: {
    titleFontSize: '16px',
    padding: '20px 20px 16px 20px',
    iconSize: '18px',
    closeSize: '16px',
    closeIconSize: '16px',
    closeMargin: '16px',
    titleTextColor: 'rgba(15, 23, 42, 1)',
    textColor: 'rgba(77, 83, 97, 1)',
    iconColorError: '#EF4444FF',
    borderRadius: '16px',
    titleFontWeight: '700',
  },
  Breadcrumb: {
    separatorColor: 'rgba(233, 237, 244, 1)',
    itemTextColorActive: 'rgba(90, 26, 120, 1)',
    itemTextColorPressed: 'rgba(37, 0, 59, 1)',
    itemBorderRadius: '8px',
    itemTextColorHover: 'rgba(90, 26, 120, 1)',
    itemColorHover: 'rgba(110, 1, 162, 0.15)',
    itemColorPressed: 'rgba(90, 26, 120, 0.2)',
    fontWeightActive: '500',
  },
  Message: {
    padding: '16px',
    maxWidth: '480px',
    minWidth: '300px',
    borderRadius: '8px',
    border: '1px solid #e7ebf3',
    boxShadow: 'box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10);',
    lineHeight: '22px',
  },
  Popover: {
    padding: '16px 20px',
    borderRadius: '8px',
    fontSize: '13px',
    arrowHeight: '8px',
    color: '#F8FAFCFF',
  },
  Popconfirm: {
    fontSize: '13px',
  },
  DatePicker: {
    itemBorderRadius: '8px',
    panelBorderRadius: '8px',
  },
  Pagination: {
    buttonBorder: '1px solid #E9EDF4',
    buttonColorHover: 'rgba(0, 0, 0, 0.05)',
    buttonColorPressed: 'rgba(233, 237, 244, 0)',
    buttonBorderHover: '1px solid rgba(0,0,0,0)',
    buttonBorderPressed: '1px solid rgba(0,0,0,0)',
    buttonIconColor: 'rgba(13, 0, 26, 0.7)',
    itemTextColorHover: '#9500D7FF',
    itemColorActive: 'rgba(233, 237, 244, 1)',
    itemColorActiveHover: 'rgba(233, 237, 244, 0.5)',
    itemBorderActive: '1px solid rgba(0,0,0,0)',
    itemTextColorActive: 'rgba(13, 0, 26, 0.7)',
  },
  Avatar: {
    borderRadius: '6px',
    heightHuge: '64px',
    heightLarge: '40px',
    heightMedium: '32px',
    heightSmall: '24px',
    heightTiny: '20px',
  },
  PageHeader: {
    titleFontSize: '18px',
    fontSize: '12px',
  },
  Checkbox: {
    sizeSmall: '16px',
    sizeMedium: '18px',
    sizeLarge: '20px',
    labelPadding: '2px 8px',
    fontSizeSmall: '13px',
    fontSizeLarge: '16px',
    borderRadius: '6px',
    fontSizeMedium: '14px',
    labelLineHeight: '1.2',
  },
  Tooltip: {
    textColor: 'var(--color-body)',
  },
}
